module.exports = __webpack_public_path__ + "static/media/project-hhmmss.fe489392.jpg";